import React from 'react';
import BannerAlert from '../Alert';

const MAINTENANCE = process.env.REACT_APP_MAINTENANCE;
const MAINTENANCE_TITLE = process.env.REACT_APP_MAINTENANCE_TITLE;
const MAINTENANCE_DESCRIPTION = process.env.REACT_APP_MAINTENANCE_DESCRIPTION;

const INCIDENT = process.env.REACT_APP_INCIDENT;
const INCIDENT_TITLE = process.env.REACT_APP_INCIDENT_TITLE;
const INCIDENT_DESCRIPTION = process.env.REACT_APP_INCIDENT_DESCRIPTION;

const SUCCESS = process.env.REACT_APP_SUCCESS_MESSAGE;
const SUCCESS_TITLE = process.env.REACT_APP_SUCCESS_TITLE;
const SUCCESS_DESCRIPTION = process.env.REACT_APP_SUCCESS_DESCRIPTION;

const alerts = [
  {
    condition: /true/i.test(INCIDENT),
    title: INCIDENT_TITLE,
    description: INCIDENT_DESCRIPTION,
    type: 'error',
  },
  {
    condition: /true/i.test(MAINTENANCE),
    title: MAINTENANCE_TITLE,
    description: MAINTENANCE_DESCRIPTION,
    type: 'warning',
  },
  {
    condition: /true/i.test(SUCCESS),
    title: SUCCESS_TITLE,
    description: SUCCESS_DESCRIPTION,
    type: 'success',
  },
];

const MaintenanceBanner = () => {
  return (
    <>
      {alerts
        .filter(({ condition }) => condition)
        .map(({ title, description, type }, i) => (
          <BannerAlert
            key={i}
            message={title}
            description={description}
            type={type}
          />
        ))}
    </>
  );
};

export default MaintenanceBanner;
